import actionTypes from '../webActionTypes';
import { push, replace } from 'react-router-redux'
import CupoyRouter from "components/commons/router/CupoyRouter";

function replaceRoutePath(path) {
	return function(dispatch, getState) {
		return dispatch(replace(path));
	};
}

// ------------------------------
// Cupoy State 轉址
// ------------------------------
function cupoyStateGo(statename, params, querys, locationState) {

	return function(dispatch, getState) {

		if(!CupoyRouter.hasState(statename)) {
			throw new Error('CupoyState has not state: ' + statename);
		}

		const url = CupoyRouter.getPathname(statename, params);
		const search = CupoyRouter.getQueryUrl(querys);

		let location =  {
		    pathname: url,
		    search: search,
		    state: locationState,
		};

		return dispatch(push(location));
	};
}

// ------------------------------
// Cupoy State 轉址（不會記錄上下頁）
// ------------------------------
function cupoyStateReplace(statename, params, querys, locationState) {

	return function(dispatch, getState) {

		if(!CupoyRouter.hasState(statename)) {
			throw new Error('CupoyState has not state: ' + statename);
		}

		const url = CupoyRouter.getPathname(statename, params);
		const search = CupoyRouter.getQueryUrl(querys);

		let location =  {
		    pathname: url,
		    search: search,
		    state: locationState,
		};

		return dispatch(replace(location));
	};
}

// ------------------------------
// Cupoy State 轉至預設頁
// ------------------------------
function cupoyStateGoOtherwise() {

	return function(dispatch, getState) {

		const otherwise = CupoyRouter.getOtherwise();

		if(otherwise) {
			return dispatch(replace(otherwise));	
		}
	};
}

function storeScrollPosition(key, scrollTop) {
	const payload = {
		key,
		scrollTop
	};
	return { type: actionTypes.storeScrollPosition, payload };
}

function storeRenderedIndex(key, event) {
	const payload = {
		key,
		event
	};
	return { type: actionTypes.storeRenderedIndex, payload };
}

// function setLoginStatus(payload) {
// 	return { type: actionTypes.setLoginStatus, payload };
// }

function showLogoutModal(payload) {
	return { type: actionTypes.showLogoutModal, payload };
}

function closeLogoutModal(payload) {
	return { type: actionTypes.closeLogoutModal, payload };
}

// ------------------------------
// 開啟確認Dialog
// ------------------------------
function openConfirmDialog(data) {

	const payload = {
        title: data.title,
        description: data.description,
        isPromise: data.isPromise,
        confirmCallback: data.confirmCallback,
        confirmPromise: data.confirmPromise,
        cancelCallback: data.cancelCallback,
        confirmName: data.confirmName,
    };
	return { type: actionTypes.openConfirmDialog, payload };
}

// ------------------------------
// 關閉確認Dialog
// ------------------------------
function closeConfirmDialog(payload) {
	return { type: actionTypes.closeConfirmDialog, payload };
}

// ------------------------------
// 開啟警告Dialog
// ------------------------------
function openAlartDialog(data) {

	const payload = {
        title: data.title,
        description: data.description,
        confirmName: data.confirmName,
        callback: data.callback,
    };
	return { type: actionTypes.openAlartDialog, payload };
}

// ------------------------------
// 關閉警告Dialog
// ------------------------------
function closeAlartDialog(payload) {
	return { type: actionTypes.closeAlartDialog, payload };
}

const webActions = {
	replaceRoutePath,
	cupoyStateGo,
	cupoyStateReplace,
	cupoyStateGoOtherwise,
	storeScrollPosition,
	storeRenderedIndex,
	showLogoutModal,
	closeLogoutModal,
	openConfirmDialog,
	closeConfirmDialog,
	openAlartDialog, // 開啟警告Dialog
	closeAlartDialog, // 關閉警告Dialog
};

export default webActions;


// WEBPACK FOOTER //
// ./src/actions/creators/webActions.js